module.exports = __webpack_public_path__ + "img/ImageUpload.7e4d3b89.svg";